import { createAPI } from '@common'

// MediaCloudNisLiveConsole
export default {
  // 删除评论
  postDiscussDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0efmfuf', 'post', config),
  // 提交官方回复
  postDiscussSubmit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0tvcnju', 'post', config),
  // 直播评论置顶
  postDiscussTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0upq', 'post', config),
  // 直播评论取消置顶
  postDiscussUntop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0voupq', 'post', config),
  // 直播评论审核通过
  postDiscussPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0qbtt', 'post', config),

  // 保存直播设置
  postNisLiveConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0ojt0dpogjh', 'post', config),
  // 获取直播设置
  getNisLiveConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0ojt0dpogjh', 'get', config),

  // 获取直播在线人数
  getNisLiveUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0ojt0dpvout', 'get', config, {
      neverLoading: true
    }),
  // 开始直播
  postNisLiveStart: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0tubsu', 'post', config),
  // 结束直播
  postNisLiveStop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0tupq', 'post', config),
  // 管理员信息查询
  getManagerConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0nbobhfs0dpogjh',
      'get',
      config,
      {
        neverLoading: true
      }
    ),
  // 管理员信息修改
  postManagerConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0nbobhfs0dpogjh0vqebuf',
      'post',
      config
    ),
  //发送报道
  postInteraction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu', 'post', config),
  //修改报道
  updateInteraction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu0vqebuf',
      'post',
      config
    ),
  //删除报道
  deleteInteraction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu', 'DELETE', config),
  //置顶报道
  postInteractionTop: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu0upq', 'post', config),
  //取消置顶报道
  postInteractionCancel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu0upq0dbodfm',
      'post',
      config
    ),
  getInteractionDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu0efubjm',
      'get',
      config,
      {
        neverLoading: true
      }
    ),
  // 图册直播相关
  // 选用图片
  postLiveSelectAtlas: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0tfmfduBumbt', 'post', config),
  // 查看选用图片
  postLiveAtlasList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0bumbtMjtu', 'post', config),
  // 删除已经选用的图片
  postLiveDeleteAtlas: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0efmfufBumbt', 'post', config),
  // 获取图册中图片数量
  getLiveGetAtlasCount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuBumbtDpvou', 'get', config),
  // 清空已经选用的图片
  deleteAllAtlas: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0efmfufBmmBumbt', 'post', config),
  // 清空已经选用的图片
  liveAutoStart: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0bvupTubsu', 'post', config),
  // 获取直播统计数据
  getLiveGetStatistics: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuTubujtujdt', 'get', config),
  getE5Actions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0f60bdujpot', 'get', config, vconfig),
  //发布草稿箱报道
  pubInteraction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0joufsbdujpo0sfqpsu0qvc', 'post', config),
  // 新建直播推荐
  addLiveRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfdpnnfoe0bee', 'post', config),
  // 修改直播推荐
  updateLiveRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfdpnnfoe0vqebuf', 'post', config),
  // 直播推荐详情
  getLiveRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfdpnnfoe', 'get', config),
  // 删除直播推荐
  deleteLiveRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfdpnnfoe0efmfuf', 'get', config),
  // 直播推荐排序
  orderLiveRecommend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfdpnnfoe0psefs', 'post', config),
  // 表单征集、关联稿件选用发布到直播互动
  saveLiveDiscuss: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0ejtdvtt0tbwfMjwfEjtdvtt',
      'post',
      config
    ),
  // 更新直播简介
  updateLiveIntroduction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0jouspevdujpo', 'post', config)
}
